import React, { PureComponent } from 'react';
import { MANIPAL_CONFIG } from '../ClientLogin/constants';
import StyledClientLogin from '../ClientLogin/styledClientLogin';
import { ClientLandingHeader } from './clientLandingHeader';
import { constants } from '../../devUtils';
import { ManipalcignaHeaderProps } from './manipalcignaHeaderDataHandler';

class ManipalcignaHeader extends PureComponent {
  componentDidMount() {
    const stickyBodyEle = document.querySelector('.stickyBody');
    if (stickyBodyEle) {
      stickyBodyEle.classList.add('manipalcignaStickyBody');
    }
  }

  render() {
    const {
      isOnlyMerchandise = false,
      cart,
      loggedIn,
      handleLogout,
      history: {
        location: {
          pathname = '',
        } = {},
      } = {},
      handleShowLogin,
    } = this.props;
    const {
      slider_images,
      logo,
      about_title,
      about_description,
      secondary_title,
      portal_name,
      redirect_loginSuccess,
      top_banner,
      welcome_title,
      welcome_description,
      brand_logo,
      ...otherProps
    } = MANIPAL_CONFIG;
    return (
      <StyledClientLogin {...otherProps}>
        <ClientLandingHeader
          brand_logo={brand_logo}
          logo={logo}
          portal_name={portal_name}
          top_banner={top_banner}
          isOnlyMerchandise={pathname === constants.LINK_CLIENT_MANIPAL || isOnlyMerchandise}
          isLoggedIn={loggedIn}
          handleShowLogin={handleShowLogin}
          handleLogout={handleLogout}
          pathname={pathname}
          cart={cart}
        />
      </StyledClientLogin>
    );
  }
}

ManipalcignaHeader.propTypes = ManipalcignaHeaderProps;
export default ManipalcignaHeader;



// WEBPACK FOOTER //
// client/containers/HeaderContainer/manipalcignaHeader.js